/**
 * The icons a price badge can lead with, as the keys a price stores. This is
 * the client copy of BADGE_ICON_KEYS in packages/schemas (which the API
 * validates against); apps/api/src/products/badgeIconKeys.test.ts asserts the
 * two lists equal, so a new icon has to land in both.
 *
 * Kept free of imports so the API test can require it without a React or
 * Heroicons resolution — components/BadgeIcon.js maps the keys to icons.
 */
const BADGE_ICON_KEYS = [
  'star',
  'sparkles',
  'fire',
  'bolt',
  'rocket',
  'trophy',
  'check',
  'x-mark',
  'plus',
  'arrow-right',
  'check-badge',
  'check-circle',
  'shield-check',
  'thumbs-up',
  'heart',
  'smile',
  'light-bulb',
  'sun',
  'moon',
  'gift',
  'tag',
  'percent',
  'dollar',
  'banknotes',
  'credit-card',
  'shopping-bag',
  'shopping-cart',
  'truck',
  'clock',
  'calendar',
  'bell',
  'megaphone',
  'trending-up',
  'chart',
  'refresh',
  'lock',
  'key',
  'ticket',
  'users',
  'academic-cap',
  'book',
  'music',
  'video',
  'document',
  'download',
  'mobile',
  'camera',
  'paint-brush',
  'puzzle',
  'cube',
  'globe',
  'map-pin',
  'storefront',
  'tools',
  'beaker',
  'lifebuoy',
  'chat',
  'envelope',
  'phone',
  'cake',
  'scale',
  'eye',
];

export default BADGE_ICON_KEYS;
